export class AreaZucchettiModel {
    public type_user: TypeUserModel[];
    public society:SocietyModel[];
    public operational_function:OperationalFunctionModel[];
    public notes: string;
}

export class BaseModel{
  links:any[];
  id: number;
  value:string;
  description:string;
}
export class TypeUserModel extends BaseModel{}
export class SocietyModel extends BaseModel{}
export class OperationalFunctionModel extends BaseModel{}